import { render, staticRenderFns } from "./OldDateConvertBanner.vue?vue&type=template&id=ad677394&scoped=true&"
import script from "./OldDateConvertBanner.vue?vue&type=script&lang=js&"
export * from "./OldDateConvertBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad677394",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad677394')) {
      api.createRecord('ad677394', component.options)
    } else {
      api.reload('ad677394', component.options)
    }
    module.hot.accept("./OldDateConvertBanner.vue?vue&type=template&id=ad677394&scoped=true&", function () {
      api.rerender('ad677394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/festivals/temp/OldDateConvertBanner.vue"
export default component.exports